"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSubplaceParamsProvider = exports.constructNewSearchWithClearedColumnSelection = exports.constructNewSearchForColumnSelection = void 0;
const tslib_1 = require("tslib");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const shared_urls_1 = require("@tableau/shared-urls");
const react_1 = tslib_1.__importDefault(require("react"));
const reselect_1 = require("reselect");
function constructNewSearchForColumnSelection(search, columnId) {
    const paramValuesMap = (0, data_catalog_shared_1.searchToParamValuesMap)(search);
    const columns = paramValuesMap[shared_urls_1.CatalogUrlParamKeys.column];
    if (columns && columns.indexOf(columnId) >= 0) {
        (0, data_catalog_shared_1.removeParamValue)(paramValuesMap, shared_urls_1.CatalogUrlParamKeys.column, columnId);
    }
    else {
        (0, data_catalog_shared_1.setParamValues)(paramValuesMap, shared_urls_1.CatalogUrlParamKeys.column, [columnId]);
    }
    return (0, data_catalog_shared_1.paramValuesMapToSearch)(paramValuesMap);
}
exports.constructNewSearchForColumnSelection = constructNewSearchForColumnSelection;
function constructNewSearchWithClearedColumnSelection(search) {
    const paramValuesMap = (0, data_catalog_shared_1.searchToParamValuesMap)(search);
    const columns = paramValuesMap[shared_urls_1.CatalogUrlParamKeys.column];
    if (columns) {
        (0, data_catalog_shared_1.setParamValues)(paramValuesMap, shared_urls_1.CatalogUrlParamKeys.column, []);
    }
    return (0, data_catalog_shared_1.paramValuesMapToSearch)(paramValuesMap);
}
exports.constructNewSearchWithClearedColumnSelection = constructNewSearchWithClearedColumnSelection;
class TableSubplaceParamsProvider extends react_1.default.Component {
    render() {
        return (react_1.default.createElement(data_catalog_shared_1.UrlSearchProvider, null, urlSearch => (react_1.default.createElement(TableSubplaceParamsProviderInternal, { urlSearch: urlSearch }, this.props.children))));
    }
}
exports.TableSubplaceParamsProvider = TableSubplaceParamsProvider;
class TableSubplaceParamsProviderInternal extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.memoizedGetFirstParamValueAsSet = (0, reselect_1.defaultMemoize)(data_catalog_shared_1.getFirstParamValueAsSet);
        this.clearColumnSelection = () => {
            const urlSearch = this.props.urlSearch;
            const newSearchWithClearedColumnSelection = constructNewSearchWithClearedColumnSelection(urlSearch.value);
            urlSearch.update(newSearchWithClearedColumnSelection);
        };
        this.updateColumnSelection = (columnId) => {
            const urlSearch = this.props.urlSearch;
            const newSearch = constructNewSearchForColumnSelection(urlSearch.value, columnId);
            urlSearch.update(newSearch);
        };
    }
    render() {
        return this.props.children({
            urlSearchValue: this.props.urlSearch.value,
            selectedColumns: this.memoizedGetFirstParamValueAsSet(this.props.urlSearch.value, shared_urls_1.CatalogUrlParamKeys.column),
            updateColumnSelection: this.updateColumnSelection,
            clearColumnSelection: this.clearColumnSelection,
        });
    }
}
//# sourceMappingURL=TableSubplaceParamsProvider.js.map